import styled from 'styled-components';

// Not ActionIcon: its subtle/gray variant resolves to the same grey it uses for
// disabled controls, so an enabled button reads as disabled.
export const GhostIconButton = styled.button<{ $size?: number }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: ${({ $size = 32 }) => $size / 16}rem;
	height: ${({ $size = 32 }) => $size / 16}rem;
	flex-shrink: 0;
	border: none;
	border-radius: var(--mantine-radius-sm);
	background: transparent;
	color: var(--mantine-color-gray-9);
	cursor: pointer;
	transition:
		background-color 100ms ease-out,
		color 100ms ease-out;

	&:hover:not(:disabled) {
		background-color: var(--mantine-color-gray-2);
		color: var(--mantine-color-text);
	}

	&:disabled {
		color: var(--mantine-color-gray-5);
		cursor: default;
	}
`;
